// This file is auto-generated by Kubb. Do not edit manually.
/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const redeterminationSchema = z.object({
  entryPointType: z.enum(["REDETERMINATION"]),
  memberId: z.string(),
  redeterminationDate: z
    .string()
    .date()
    .describe("The date redetermination is due."),
  state: z.string(),
  type: z.enum(["VANCE_REDETERMINATION"]),
  workspaceId: z.string(),
});
